import EdTaskBoardRecreateShapes from '../ed-wbo-drawer-recreate-shapes';
import EdTaskBoardManageState from '../ed-wbo-drawer-manage-state';
import WboDrawerTools from '@/components/common/ed-board/ed-board-tools/ed-wbo-drawer/wbo-drawer-tools';
import { BoardAction, BoardActionType } from '../board-actions.model';
import BoardTool from '@/components/common/ed-board/ed-board-tools/board-tool.interface';

export default class EdWboDrawerUndo {

    private recreateShapes: EdTaskBoardRecreateShapes;
    private manageState: EdTaskBoardManageState;
    private wboDrawerTools: WboDrawerTools;

    private addInverseActionToRedoStack(boardAction: BoardAction): void {
        const inverseActionType: BoardActionType = BoardAction.getInverseActionType(boardAction.actionType);
        this.manageState.addBoardActionToRedoStack(boardAction.annotations, inverseActionType, boardAction.actionParams, true);
    }

    private undoAction: Function = (): void => {
        const boardAction: BoardAction = this.manageState.getLastUndoBoardAction();

        if (BoardAction.isValidBoardAction(boardAction)) {

            this.addInverseActionToRedoStack(boardAction);


            if (boardAction.annotations.length > 1) {
                this.recreateShapes.processSeveralAnnotations(
                    boardAction.actionType,
                    boardAction.annotations.map(annotation => this.manageState.getBoardActionObjectByActionType(annotation, boardAction.actionType)),
                    this.manageState.getAnnotationChildren()
                );
            } else {
                const annotation = boardAction.annotations[0];
                const children: any[] = this.manageState.getAnnotationChildren().get(annotation.id);
                this.recreateShapes.processBoardAction(
                    boardAction.actionType,
                    this.manageState.getBoardActionObjectByActionType(annotation, boardAction.actionType),
                    children
                );
            }
        }
    }

    private undoTool: BoardTool = { //The new tool
        name       : 'Undo',
        listeners  : {},
        oneTouch   : true,
        draw       : (data: any) => true,
        onstart    : this.undoAction,
        icon       : '/assets/tools/undo-redo/undo/undo.svg',
        mouseCursor: 'crosshair',
        showMarker : true
    }

    constructor(tools: WboDrawerTools, manageState: EdTaskBoardManageState, recreateShapes: EdTaskBoardRecreateShapes) {
        this.wboDrawerTools = tools;
        this.wboDrawerTools.add(this.undoTool);
        this.recreateShapes = recreateShapes;
        this.manageState = manageState;
    }

}
